import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {toObservable} from '@angular/core/rxjs-interop';
import {filter, map, take} from 'rxjs/operators';
import {OrganisationStore} from '../stores/organisation.store';

export const superuserGuard: CanActivateFn = () => {
  const store = inject(OrganisationStore);
  const router = inject(Router);

  if (store.initialised()) {
    return store.isSuperuser() || router.createUrlTree(['/']);
  }

  return toObservable(store.initialised).pipe(
    filter(init => init),
    take(1),
    map(() => store.isSuperuser() || router.createUrlTree(['/']))
  );
};
